module.exports = __webpack_public_path__ + "static/img/helado.4206007.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/helado.gif
// module id = hZ3C
// module chunks = 4